import styled from "styled-components";
import { HeadLine1 } from "../../components/typography/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px 10px 20px;
  position: relative;
  min-width: 0;

  @media (max-width: 768px) {
    width: 100%;
    padding: 10px 16px 32px;
    box-sizing: border-box;
  }
`
export const InstanceName = styled(HeadLine1)`
  color:${({theme}) => theme.palette[800]};
  margin-top:10px;
  margin-bottom:10px;
`
export const NavWrapper = styled.div`
  border-bottom: ${({theme}) => `1px solid ${theme.grey[350]}`};
  position: relative;
  display: flex;
  margin-right:10px;
  margin-top:50px;
  &>div{
    position: absolute;
    bottom:-1px;
    left:0px;
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-right: 0;
    margin-top: 24px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;

    & > div {
      position: relative;
      bottom: auto;
      left: auto;
      width: max-content;
      min-width: 100%;
    }
  }
`

export const TabContainer = styled.div`
  margin-top:20px;
  min-width: 0;
`

export const ProfileForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 360px;
  max-width: 100%;
  gap: 20px;
`

export const PersonalizationWrapper = styled.div`
  width: 360px;
  max-width: 100%;
  min-width: 0;
`


export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 10px 20px;
  width: 400px;
  /* height: 408px; */
  box-sizing: border-box;
  background-color: ${({theme}) => theme.palette[10]};
  border-radius: 8px;
`

export const HeadWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: flex-start;
`
export const BodyModal = styled.div`
  /* display:flex; */
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding:0px 10px;
  width:100%;
`
export const Icon = styled.img`
  &:hover{
    cursor: pointer;
  }
`
export const PasswordWrapper = styled.div`
  position: relative;
  width:100%;
  margin-bottom: 10px;
`

export const LabelWrapper = styled.div`
  gap:6px;
  display: flex;
  flex-direction: column;
`
